import type { FlashSaleRotation } from '../../utils/campaign/flashSaleRotation';

/**
 * Spring Sale Flash Sale rotation schedule
 * All times are in SGT (Asia/Singapore timezone)
 * Format: 'YYYY-MM-DD HH:mm:ss'
 */
export const SPRING_FLASH_SALE_ROTATIONS: FlashSaleRotation[] = [
  {
    startDate: '2026-03-18 15:00:00',
    endDate: '2026-03-19 15:00:00',
    collectionName: 'Spring Sale Flash Sale 1',
    campaignUrl: '/campaign/spring-sale/',
  },
  {
    startDate: '2026-03-19 15:00:00',
    endDate: '2026-03-20 15:00:00',
    collectionName: 'Spring Sale Flash Sale 2',
    campaignUrl: '/campaign/spring-sale/',
  },
  {
    startDate: '2026-03-20 15:00:00',
    endDate: '2026-03-21 15:00:00',
    collectionName: 'Spring Sale Flash Sale 3',
    campaignUrl: '/campaign/spring-sale/',
  },
  {
    startDate: '2026-03-21 15:00:00',
    endDate: '2026-03-22 15:00:00',
    collectionName: 'Spring Sale Flash Sale 4',
    campaignUrl: '/campaign/spring-sale/',
  },
  {
    startDate: '2026-03-22 15:00:00',
    endDate: '2026-03-23 15:00:00',
    collectionName: 'Spring Sale Flash Sale 5',
    campaignUrl: '/campaign/spring-sale/',
  },
  {
    startDate: '2026-03-23 15:00:00',
    endDate: '2026-03-24 15:00:00',
    collectionName: 'Spring Sale Flash Sale 6',
    campaignUrl: '/campaign/spring-sale/',
  },
  {
    startDate: '2026-03-24 15:00:00',
    endDate: '2026-03-25 15:00:00',
    collectionName: 'Spring Sale Flash Sale 7',
    campaignUrl: '/campaign/spring-sale/',
  },
];

export const SPRING_FLASH_SALE_TIMEZONE = 'Asia/Singapore';

export const SPRING_SALE_CAMPAIGN_CONFIG = {
  bannerTitle: 'New deals every 24 hours!',
  bannerSubtitle: 'Grab your favorites fast.',
  textBannerCopy: '80% off across the selection',
} as const;
